import { Link, useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const handleHashLink = (hash: string) => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const footerLinks: Record<string, { label: string; action: () => void }[]> = {
    Solutions: [
      { label: 'AI Automation', action: () => handleHashLink('what-we-do') },
      { label: 'Data Processing', action: () => handleHashLink('what-we-do') },
      { label: 'Custom Agents', action: () => handleHashLink('what-we-do') },
      { label: 'System Integration', action: () => handleHashLink('what-we-do') },
    ],
    Industries: [
      { label: 'Finance', action: () => handleHashLink('industries') },
      { label: 'Healthcare', action: () => handleHashLink('industries') },
      { label: 'Legal', action: () => handleHashLink('industries') },
      { label: 'Real Estate', action: () => handleHashLink('industries') },
    ],
    Company: [
      { label: 'About Us', action: () => navigate('/about') },
      { label: 'How It Works', action: () => handleHashLink('how-it-works') },
      { label: 'Case Studies', action: () => handleHashLink('case-studies') },
      { label: 'Contact', action: () => handleHashLink('contact') },
    ],
    Resources: [
      { label: 'Blog', action: () => {} },
      { label: 'Documentation', action: () => {} },
      { label: 'Support', action: () => {} },
      { label: 'Privacy Policy', action: () => {} },
    ],
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <Link to="/">
                <img
                  src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/48e5624723f4619649fba9155ec5b9b4.png"
                  alt="BreakthruAI Logo"
                  className="h-20 w-auto cursor-pointer"
                />
              </Link>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              Intelligent Automation & Systems Architecture
            </p>
            <div className="w-16 h-0.5 bg-teal-500 mb-4"></div>
            <p className="text-slate-500 text-xs leading-relaxed">
              Serving finance, healthcare, legal, and real estate organizations nationwide.
            </p>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-white font-semibold mb-4">{category}</h4>
              <div className="w-10 h-px bg-slate-700 mb-4"></div>
              <ul className="space-y-3">
                {links.map((link, index) => (
                  <li key={index}>
                    <button
                      onClick={link.action}
                      className="text-sm text-slate-400 hover:text-teal-400 transition-colors hover:underline cursor-pointer bg-transparent border-none p-0 text-left"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-500">
              © {new Date().getFullYear()} BreakthruAI. All rights reserved.
            </p>

            <div className="flex items-center space-x-5">
              <a href="https://linkedin.com" target="_blank" rel="nofollow noopener noreferrer" className="w-6 h-6 flex items-center justify-center text-slate-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="nofollow noopener noreferrer" className="w-6 h-6 flex items-center justify-center text-slate-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="https://github.com" target="_blank" rel="nofollow noopener noreferrer" className="w-6 h-6 flex items-center justify-center text-slate-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-github-fill text-xl"></i>
              </a>
              <a href="mailto:hello@breakthruai.com" className="w-6 h-6 flex items-center justify-center text-slate-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
